import {useEffect, useState} from 'react';

/**
 * debounce
 * @param {function} fn
 * @param {Number} ms
 * @return {function}
 */
function debounce(fn, ms) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      // eslint-disable-next-line no-invalid-this
      fn.apply(this, args);
    }, ms);
  };
}

/**
 * React hook to use window size
 * @return {Array}
 */
export function useWindowDimension() {
  const [dimension, setDimension] = useState([
    window.innerWidth,
    window.innerHeight,
  ]);
  useEffect(() => {
    const debouncedResizeHandler = debounce(() => {
      setDimension([window.innerWidth, window.innerHeight]);
    }, 100); // 100ms
    window.addEventListener('resize', debouncedResizeHandler);
    return () => window.removeEventListener('resize', debouncedResizeHandler);
  }, []);
  return dimension;
}

/**
 * React hook to use window width only
 * @return {Number}
 */
export function useWindowWidth() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const debouncedResizeHandler = debounce(() => {
      setWindowWidth(window.innerWidth);
    }, 100); // 100ms
    window.addEventListener('resize', debouncedResizeHandler);
    return () => window.removeEventListener('resize', debouncedResizeHandler);
  }, []);
  return windowWidth;
}
